<h2 mat-dialog-title translate>dialog.loading.excel.title</h2>
<mat-divider class="dialog__divider--top"></mat-divider>
<mat-dialog-content>
  <div class="content_dialog">
    <p translate>dialog.loading.excel.text</p>
  </div>
</mat-dialog-content>
